import classNames from 'classnames';

import { DividerProps } from './types';

import styles from './Divider.module.scss';

export const Divider = ({ gutters = 'small', customGutters, className }: DividerProps) => {
  return (
    <div
      className={classNames(
        styles.divider,
        {
          [styles.small_gutters]: gutters === 'small',
          [styles.medium_gutters]: gutters === 'medium',
          [styles.large_gutters]: gutters === 'large',
        },
        className,
      )}
      data-testid="gafe-divider"
      style={{ margin: `${customGutters}px 0` }}
    />
  );
};
